<!-- 设备工况 -->
<template>
    <div class='container containerBox'>
        <el-row :gutter="20">
            <el-col :span="12">
                <div class="fault-box">
                    <ul class="fault-item fault-header">
                        <li>冷冻设备</li>
                        <li>运行时间</li>
                        <li>启动次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="fault-box">
                    <ul class="fault-item fault-header">
                        <li>冷却设备</li>
                        <li>运行时间</li>
                        <li>启动次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                    <ul class="fault-item">
                        <li>1#主机</li>
                        <li>0小时</li>
                        <li>0次数</li>
                    </ul>
                </div>
            </el-col>
		</el-row>
    </div>
</template>

<script>
export default {
    name:  'devicerunningstatus',
    data() {
      return {
      };
    },

    methods: {}
}

</script>
<style lang='less' scoped>
.fault-header{
    background-color: #f5f7fa;
    border-bottom: 1px solid #f5f7fa;
	margin-bottom: 10px;
}
.fault-box{
	padding: 20px;
}
.fault-item{
    font-size: 0;
    text-align: center;
    &:nth-child(2n){
        background-color: #fafafa;
    }
    &:hover{
        background-color: #f5f7fa;
    }
	li{
		display: inline-block;
		vertical-align: middle;
		line-height: 40px;
		height: 40px;
		width: 33.3%;
		font-size: 14px;
	}
}
</style>